function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#444445",
  d: "M18,15.4H4.3v-1H18c0.7,0,1.3-0.6,1.3-1.3V4.3C19.3,3.6,18.8,3,18,3H4.3C3.6,3,3,3.6,3,4.3v8.6H2V4.3 C2,3,3,2,4.3,2H18c1.3,0,2.3,1,2.3,2.3v8.8C20.3,14.4,19.3,15.4,18,15.4z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#444445",
  d: "M9.4,15.4H2.3c-1.3,0-2.3-1-2.3-2.3V2.3C0,1,1,0,2.3,0h7.1c1.3,0,2.3,1,2.3,2.3h-1c0-0.7-0.6-1.3-1.3-1.3H2.3 C1.6,1,1,1.6,1,2.3l0,10.8c0,0.7,0.6,1.3,1.3,1.3h7.1L9.4,15.4z"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 11.6,
  y: 3,
  fill: "#444445",
  width: 1.3,
  height: 1
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 12.9,
  y: 4,
  fill: "#444445",
  width: 1.3,
  height: 1
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 11.6,
  y: 5,
  fill: "#444445",
  width: 1.3,
  height: 1
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 12.9,
  y: 6,
  fill: "#444445",
  width: 1.3,
  height: 1
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 11.6,
  y: 7,
  fill: "#444445",
  width: 1.3,
  height: 1
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 12.9,
  y: 8,
  fill: "#444445",
  width: 1.3,
  height: 1
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#444445",
  d: "M13.3,9.5h-0.7c-0.3,0-0.5,0.2-0.5,0.5v1.7c0,0.3,0.2,0.5,0.5,0.5h0.7c0.3,0,0.5-0.2,0.5-0.5V10 C13.8,9.7,13.5,9.5,13.3,9.5z M13.5,11.6c0,0.1-0.1,0.2-0.2,0.2h-0.7c-0.1,0-0.2-0.1-0.2-0.2v0c0-0.1,0.1-0.2,0.2-0.2h0.7 C13.4,11.4,13.5,11.5,13.5,11.6L13.5,11.6z"
});

var SvgFilesListingZip = function SvgFilesListingZip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#444445",
    width: "20px",
    height: "15px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.3 15.4",
    style: {
      enableBackground: "new 0 0 20.3 15.4"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilesListingZip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/files_listing_zip.cf642ff1.svg";
export { ForwardRef as ReactComponent };